module.exports = __webpack_public_path__ + "static/media/1@1024w.9a19124a.jpg";